import React, { FC } from 'react';
import styled from 'styled-components';
import Icon from '../assets/images/logo.svg';

const StyledLogo = styled.div`
  display: flex;
  text-transform: uppercase;
  font-size: 1.5em;
  letter-spacing: 0.4em;
  justify-content: flex-start;
  width: 100%;

  @media (max-width: 500px) {
    font-size: 0.8em;
    justify-content: space-between;
    margin: 0;
  }

  .logo-container {
    display: flex;
    flex: 2;
  }
  .left-column {
    display: flex;
    align-items: center;
    @media (max-width: 868px) {
      flex: 1;
    }
    .economics {
      font-family: Nimbus;
      color: var(--darkestgrey);
      letter-spacing: 3px;
    }
  }

  .right-column {
    font-family: Rift_Bold;
    letter-spacing: 2px;
    font-size: 0.9em;
    display: flex;
    align-items: center;
    text-align: left;
    @media (max-width: 868px) {
      flex: 1;
    }
  }

  .divider {
    border-left: 1px solid var(--darkgrey);
    margin: 10px 10px;
  }
`;

export const Logo: FC<any> = ({ title, toggleMenu, scrollTo }) => (
  <StyledLogo>
    <div className="logo-container">
      <div className="left-column" onClick={scrollTo}>
        <Icon style={{ height: '100%', width: '100%' }} />
      </div>
      <div className="divider"> </div>
      <div className="right-column">{title}</div>
    </div>
    <Hamburger onClick={toggleMenu}>
      <div></div>
      <div></div>
      <div></div>
    </Hamburger>
  </StyledLogo>
);

const Hamburger = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  background-color: var(--white);
  width: 55px;
  margin: 10px 20px 10px 10px;
  @media (min-width: 1100px) {
    display: none;
  }

  @media (max-width: 600px) {
    width: 40px;
  }

  div {
    flex: 1;
    height: 7px;
    margin: 5px;
    min-width: 100%;
    background: var(--red);
    @media (max-width: 600px) {
      height: 5px;
      margin: 2.5px;
    }
  }
`;
